import { z } from "zod";

export enum UserPolicy {
  /** @deprecated */
  blockedFromCommunity = 1,
  accessTeacherResourceSite = 2,
  viewSchoolsHomepage = 3,
  /** @deprecated */
  deletableByCommunityAdmin = 4,
  cantChangeEmail = 5,
  blockedFromMagicLinkAuth = 6,
  blockedFromDMs = 7,
  blockedFromFriends = 8,
  blockedFromPurchasing = 9,
  blockedFromAIChat = 10,
  blockedFromAIRecommendations = 11,
  blockedFromManagingProfiles = 12,
  blockedFromCreatingGroups = 13,
  blockedFromCommunityUnlessYouthEnabled = 14,
  allowQAEndpoints = 15,
}

export const userPolicyEnum = z.enum(UserPolicy);
